/**
 * Applies product media alt text to gallery images (including app-injected images like Rubik).
 * Reads alt map from #product-media-alts JSON emitted on product pages.
 */
(function () {
  const dataEl = document.getElementById('product-media-alts');
  if (!dataEl) return;

  let altMap;
  try {
    altMap = JSON.parse(dataEl.textContent);
  } catch (error) {
    return;
  }

  const productRoot =
    document.querySelector(`#${dataEl.dataset.sectionId}`) ||
    document.querySelector('.product') ||
    document;

  const getAltForImage = (img) => {
    const mediaNode = img.closest('[data-media-id]');
    if (mediaNode?.dataset?.mediaId) {
      const mediaId = mediaNode.dataset.mediaId.split('-').pop();
      if (altMap[mediaId]) return altMap[mediaId];
    }

    const src = img.currentSrc || img.src;
    if (!src) return null;

    for (const [id, alt] of Object.entries(altMap)) {
      const entry = altMap._src?.[id];
      if (entry && src.includes(entry)) return alt;
    }

    return altMap._default || null;
  };

  const KK_ALT_SUFFIX = ' from Kelley Kouture';

  const applyAlts = (root) => {
    root.querySelectorAll('img').forEach((img) => {
      let alt = img.alt?.trim();

      if (!alt) {
        alt = getAltForImage(img);
      }

      if (alt && !alt.endsWith(KK_ALT_SUFFIX)) {
        img.alt = `${alt}${KK_ALT_SUFFIX}`;
      }
    });
  };

  applyAlts(productRoot);

  const observer = new MutationObserver(() => applyAlts(productRoot));
  observer.observe(productRoot, { childList: true, subtree: true });
})();
